import React, { Component } from 'react'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'
import * as R from 'ramda'

import FlatButton from 'material-ui/FlatButton'

import SaveIcon from 'components/icons/SaveIcon'
import OkIcon from 'components/icons/SaveIcon'
import BackIcon from 'components/icons/BackIcon'
import CloseIcon from 'components/icons/CloseIcon'
import dataActions from 'actions/dataActions'
import actionBarActions from 'actions/actionbar'

let select = (state) => ({
	mode: state.mode
  , prompt: state.prompt
})

export class FormHeader extends Component{
	render(){
		let mode = this.props.mode
		let prompt = this.props.prompt
		let left, right
		let masterDetail = this.props.masterDetail
		let cancel= <FlatButton
						label="Cancel"
						primary={true}
						style={{
							height: "35px"
						  , borderRadius: "4px"
						  , width: "95px"
						  , marginLeft: "-35px"
						  , color: "white"
						}}
						disabled={mode == "view"}
					/>
		let cancelAction = ()=>{
			if( mode == "creating" || mode == "new" ){
				this.props.DELETE_YES(this.props.objectID)
				this.props.goBack()
			}else{
				 this.props.ROLLBACK()
			}
		}
		let cancelCreating = ()=>{
			this.props.ROLLBACK()
			this.props.CLOSE()
		}
		if (masterDetail){
			left={
				view: {
					icon:
						this.props.statusIcon && <div style={{
    						position:"relative"
    					  , marginTop: "12px"
    					  , marginLeft: "12px"
    					  , width:"36px"
    					  , height:"36px"
    					  , backgroundColor:"white"
    					  , borderRadius: "50%"
						  , display: "inline-block"
    					}}>
    						{this.props.statusIcon}
    					</div>
    				, action: null},
				edit: {icon:<SaveIcon />, action: this.props.COMMIT},
				new: {icon:<SaveIcon />, action: null},
				creating: {icon:<SaveIcon />, action: (this.props.commitDisabled)? null : this.props.COMMIT}
			}[mode]
			right={
				view: {icon: <CloseIcon />, action: this.props.CLOSE},
				edit: {icon: <CloseIcon />, action: this.props.CLOSE},
				new: {icon: <CloseIcon />, action: cancelCreating},
				creating: {icon: <CloseIcon />, action: this.props.CLOSE}
			}[mode]
		}else {
			left={
				view: {icon: <BackIcon />, action: this.props.goBack},
				edit: {icon: <OkIcon />, action: this.props.COMMIT},
				new: {icon: <OkIcon />, action: null},
				creating: {icon: <OkIcon />, action: this.props.COMMIT}
			}[mode]
			right={
				view: {icon: null, action: null},
				edit: {icon: cancel, action: cancelAction},
				new: {icon: cancel, action: cancelAction},
				creating: {icon: cancel, action: this.props.cancelAction || cancelAction}
			}[mode]
		}
		return(
			<header
				style={{
					width: "100%"
				  , height: "60px"
				  , backgroundColor: "rgb(62,208,176)"
				  , lineHeight: "60px"
				  , paddingTop: "0"
				  , borderBottom: "1px solid #e1e3e2"
				  , position: "relative"
				  , zIndex: "999"
				}}
				className="form-holder"
			>
                <div
                    style={{
                        float: "left"
	  				  , height: "60px"
					  , width: "50px"
					  , overflow: "hidden"
                    }}
					onClick={left.action}
                >
				        {left.icon}
                </div>
				<b
					style={{
						fontSize: "16px"
					  , marginTop: "0px"
					  , marginLeft: "8px"
					  , verticalAlign: 'middle'
					  , display: "inline-block"
					  , width: "calc(100% - 150px)"
					  , textAlign: "left"
					}}
				>
					{this.props.title}
				</b>
                <div
                    style={{
                        float: "right"
                      , width: "50px"
                      , textAlign: "right"
					  , marginRight: "10px"
                      , height: "inherit"
                    }}
					onClick={right.action}
                >
                    {right.icon}
                </div>
				<div
					key={Math.random()}
					style={{
						marginLeft: (prompt=="delete")?"0px":"100%"
					  , position: 'absolute'
					  , top: '10px'
					  , background: 'rgba(0,0,0,0.8)'
					  , padding: '11px'
					  , transition: 'all ease-in-out 0.3s'
					  , width: '100%'
					}}
					className="Prompt"
				>
					{this.props.deleteDisabled?
						<div>
							<span style={{verticalAlign: 'middle'}}>
								Can not delete {this.props.entity}: {this.props.deleteDisabled}
							</span>
							<div style={{float: "right", position:"relative", top:"-5px"}}>
								<FlatButton
									label="Cancel"
									secondary={true}
									onClick={() => {
										this.props.DELETE_NO()
									}}
								/>
							</div>
						</div>
						:
						<div>
						<span style={{verticalAlign: 'middle', fontSize: '14px'}}>
							Are you sure you want to delete this item?
						</span>
						<div style={{float: "right", position:"relative", top:"-5px"}}>
							<FlatButton
								label="Yes"
								primary={true}
								onClick={()=> {
									this.props.DELETE_YES(this.props.objectID)
									this.props.goBack()
								}}
							/>
							<FlatButton
								label="No"
								secondary={true}
								onClick={() => {
									this.props.DELETE_NO()
								}}
							/>
						</div>
					</div>
					}
				</div>
			</header>
		)
	}
}

export default connect(select,  R.mergeAll([dataActions, routerActions]))(FormHeader)



// WEBPACK FOOTER //
// ./src/components/FormHeader.js